export class AppConsts {

    static readonly tenancyNamePlaceHolderInUrl = '{TENANCY_NAME}';

    static remoteServiceBaseUrl: string;
    static remoteServiceBaseUrlFormat: string;
    static appBaseUrl: string;
    static appBaseHref: string; // returns angular's base-href parameter value if used during the publish
    static appBaseUrlFormat: string;
    static recaptchaSiteKey: string;
    static subscriptionExpireNootifyDayCount: number;

    static localeMappings: any = [];

    static readonly userManagement = {
        defaultAdminUserName: 'admin'
    };

    static readonly localization = {
        defaultLocalizationSourceName: 'SGM'
    };

    static readonly authorization = {
        encrptedAuthTokenName: 'enc_auth_token'
    };

    static readonly grid = {
        defaultPageSize: 10
    };

    static readonly roleRMC = {
        id: 1
    };

    static readonly appBaseUrlSystems = {
        admin: 'http://localhost:4200',
        financial: 'http://localhost:4300',
        novo: 'https://portal.saesp.org.br/associate/profile',
        novoTeste: ' https://frontend-dev.saesp.org.br/associate/profile'
    };
}



// WEBPACK FOOTER //
// ./src/shared/AppConsts.ts